export default __webpack_public_path__ + "static/media/background.3c0b729b.jpg";